// Config
import './config/mapbox_access_token';

// Shared modules needed by admin
import LayerUtils from './lib/layer_utils';
import DiningLayer from './layers/dining_layer';
import GenderNeutralRestroomsLayer from './layers/gender_neutral_restrooms_layer';

// Set up W namespace bindings needed by admin
W.LayerUtils = LayerUtils;

// Register layers used by admin forms
W.layers.dining = new DiningLayer();
W.layers.gender_neutral_restrooms = new GenderNeutralRestroomsLayer();

// Admin modules
import './admin/departments';
import './admin/destinations';
import './admin/dining_locations';
import './admin/draw';
import './admin/gender_neutral_restrooms';
import './admin/geojson_map';
import './admin/map_object';
import './admin/osm_search';
import './admin/point_picker';
import './admin/users';

// General admin helpers
document.addEventListener('DOMContentLoaded', () => {
	// close alert button
	const closeAlerts = document.querySelectorAll('.uw-alert .close');
	closeAlerts.forEach((closeAlert) => {
		closeAlert.addEventListener('click', (e) => {
			e.target.closest('.uw-alert').remove();
		});
	});

	// close alert after 5 seconds
	const uwAlerts = document.querySelectorAll('.uw-alert');
	uwAlerts.forEach((alert) => {
		setTimeout(() => {
			alert.classList.remove('show-alert');
			setTimeout(() => {
				alert.remove();
			}, 700);
		}, 5000);
	});

	// init datatables
	if (document.querySelector('.datatable')) {
		new simpleDatatables.DataTable('.datatable', {
			searchable: true,
			fixedHeight: true,
			perPage: 100,
			perPageSelect: [10, 25, 100],
		});
	}

	// inline editable fields — submit via fetch instead of Rails UJS remote: true
	document.querySelectorAll('.inline-editable').forEach((form) => {
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
			fetch(form.action, {
				method: form.method || 'POST',
				headers: {
					'X-CSRF-Token': csrfToken,
					'Accept': 'application/json',
				},
				body: new FormData(form),
			}).then((response) => {
				if (response.ok) {
					form.classList.add('updated');
				}
			});
		});
		form.addEventListener('animationend', () => {
			form.classList.remove('updated');
		});
	});

	// Handle data-method links (replacement for Rails UJS)
	document.querySelectorAll('a[data-method]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const message = link.dataset.confirm;
			if (message && !confirm(message)) return;

			const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
			const form = document.createElement('form');
			form.method = 'POST';
			form.action = link.href;
			form.style.display = 'none';

			const methodInput = document.createElement('input');
			methodInput.type = 'hidden';
			methodInput.name = '_method';
			methodInput.value = link.dataset.method;
			form.appendChild(methodInput);

			const csrfInput = document.createElement('input');
			csrfInput.type = 'hidden';
			csrfInput.name = 'authenticity_token';
			csrfInput.value = csrfToken;
			form.appendChild(csrfInput);

			document.body.appendChild(form);
			form.submit();
		});
	});

	// Handle data-confirm on elements without data-method (standalone confirm)
	document.querySelectorAll('[data-confirm]:not([data-method])').forEach((el) => {
		el.addEventListener('click', (e) => {
			if (!confirm(el.dataset.confirm)) {
				e.preventDefault();
			}
		});
	});
});
